import { Box, Typography, CircularProgress } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

type ExamplePlayerStateProps = Readonly<{
  minHeight?: number;
}>;

export const LoadingState = ({ minHeight = 200 }: ExamplePlayerStateProps) => (
  <Box
    sx={{
      p: 3,
      bgcolor: "background.default",
      borderRadius: 1,
      minHeight,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress />
  </Box>
);

export const EmptyState = ({ minHeight = 200 }: ExamplePlayerStateProps) => {
  const { t } = useTenantTranslation();

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "background.default",
        borderRadius: 1,
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t("noExamplesAvailable")}
      </Typography>
    </Box>
  );
};
